/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Trend_Nodata2Inputs */

const en_coinvestments_report_trend_nodata2 = /** @type {(inputs: Coinvestments_Report_Trend_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data for the selected period.`)
};

/**
* | output |
* | --- |
* | "No data for the selected period." |
*
* @param {Coinvestments_Report_Trend_Nodata2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_trend_nodata2 = /** @type {((inputs?: Coinvestments_Report_Trend_Nodata2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Trend_Nodata2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_trend_nodata2(inputs)
});
export { coinvestments_report_trend_nodata2 as "coInvestments_report_trend_noData" }